import React from 'react';

import { StaticImage } from '@nxte-nl/static-image';

import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { versionDependent } from '../../images/versionDependentExport';
import { AppDataStoreData } from '../../types/Messages';

export type Props = {
  alt: string;
  className?: string;
};

export const ModalLogoContainer = (props: Props) => {
  const { alt, className } = props;

  const storeData = messageHooks.useSubjectState(AppDataStoreData.StoreData);

  const { isLogosFromCBEOn } = featureStateHooks.useFeatureToggles();

  return (
    <StaticImage
      className={className}
      src={isLogosFromCBEOn && storeData?.modalLogo?.url.href
        ? storeData?.modalLogo?.url.href
        : versionDependent.modalLogo.src}
      alt={isLogosFromCBEOn && storeData?.modalLogo?.alt
        ? storeData?.modalLogo?.alt
        : alt}
      width={48}
      height={48}
    />
  );
};

ModalLogoContainer.displayName = 'ModalLogoContainer';
